import React, { PropTypes } from 'react';
import { Motion, spring } from 'react-motion';
import { SectionHeading } from '@chartbeat/light-side/lib/components';

import styles from './total-counter.cssm';


const TotalCounter = ({total, context}) => {

  // Adds commas every third digit and rounds decimals, e.g. 1337.2 -> 1,337
  const addCommas = (number) => Math.round(number).toLocaleString('en-US');

  return (
    <div className={styles.container}>
      <SectionHeading>total engaged minutes</SectionHeading>
      <Motion defaultStyle={{count: 0}} style={{count: spring(total)}}>
        {value => <div className={styles.counter}>{addCommas(value.count)}</div>}
      </Motion>
      {context && <div className={styles.contextText}>{context}</div>}
    </div>
  )
}

TotalCounter.propTypes = {
  total: PropTypes.number
}

export default TotalCounter;



// WEBPACK FOOTER //
// ./src/components/total-counter/total-counter.js